var FSForms = FSForms || {};
exports.FSForms = FSForms;

var INVALID_DATE = -1;
var LAST_DATE_RANGE_PICKER_KEY = 'dateRangePickerLastValue-4664fsdf6456$YTda#@%$@)_';

exports.init = function()
{
    this.processNumberInput();
    this.processDatePicker();
    this.processTimePicker();
    this.processDateTimePicker();
    this.processDateRangePicker();
    this.processSelectSearch();
    this.checkValidDateTime();
    this.checkValidDateTimePicker();
    this.processTextInputAutocomplete();
    this.activateSelectAjaxPicker();
}.bind(FSForms);

/**
 * Init number inputs - needed for IE as it deletes non valid values before nette validation
 */
FSForms.processNumberInput = function()
{
    if (window.navigator.userAgent.indexOf("Trident") > 0)
    {
        $('input[type="number"]').attr('type', 'text');
    }
};

/**
 * Init DatePicker controls.
 */
FSForms.processDatePicker = function()
{
    if($('#ffs_date_format').length)
    {  
      var ffs_date_format =  $('#ffs_date_format').val();
    }
    else
    {  
      var ffs_date_format =  'D.M.YYYY';
    }  

    $('.fs-date-picker').each(function()
    {
        var id = '#' + $(this).attr('id');
        var locale = $(this).data('locale');
        var value = $(this).val();

        var datePicker = $(id).parent().datetimepicker({
            //format: 'L',
            format: ffs_date_format,
            useStrict: true,
            locale: locale,
        });

        // clean cache for FSForms.parseDateTime
        FSForms.removeDateTime(id);

        // set default value after render
        $(id).val(value);

        // store current value into session
        datePicker.on('dp.change', function(e)
        {
            var id = '#' + $(this).children('input').attr('id');
            var val = $(id).val();
            FSForms.saveDateTime(id, val);
        });

        // Triggers 'change' after hide picker. Support for metadata logic.
        datePicker.on('dp.hide', function(e)
        {
            $(this).trigger('change');
        });

        // parse date time
        $(id).keyup(function(e)
        {
            var id = '#' + $(this).attr('id');
            var val = $(id).val();

            if(val != "")
            {
                if(e.keyCode == 9) // pressed TAB
                {
                    FSForms.saveDateTime(id, val);
                }
                else
                {
                    var dateTime = FSForms.parseDateTime(val);
                    FSForms.saveDateTime(id, dateTime);
                    window.live.removeError($(id));
                }
            }
        });

        // refresh date time
        $(id).focusout(function()
        {
            var id = '#' + $(this).attr('id');
            FSForms.refreshDateTimeValue(id);
        });

        // refresh date time
        datePicker.on('dp.show', function()
        {
            var id = '#' + $(this).children('input').attr('id');
            FSForms.refreshDateTimeValue(id);
        });

        // fix tabindex
        var tabindexEl = $(id).closest('div[tabindex]');
        var tabindex = tabindexEl.attr('tabindex');
        $(id).prop('tabindex', tabindex);
        tabindexEl.removeProp('tabindex');
    });
};

/**
 * Init TimePicker controls.
 */
FSForms.processTimePicker = function()
{
    if($('#ffs_time_format').length)
    {  
      var ffs_time_format =  $('#ffs_time_format').val();
    }
    else
    {  
      var ffs_time_format =  'HH:mm';
    }
  
    $('.fs-time-picker').each(function()
    {
        var id = '#' + $(this).attr('id');
        var locale = $(this).data('locale');
        var value = $(this).val();
        $(id).datetimepicker({
            format: 'LT',
            //format: ffs_time_format,
            useStrict: true,
            locale: locale
        });

        // set default value after render
        $(id).val(value);
    });
};

/**
 * Init DateTimePicker controls.
 */
FSForms.processDateTimePicker = function()
{
    if($('#ffs_datetime_format').length)
    {  
      var ffs_datetime_format =  $('#ffs_datetime_format').val();
    }
    else
    {  
      var ffs_datetime_format =  'D.M.YYYY HH:mm';
    }
    
    $('.fs-dateTime-picker').each(function()
    {
        var id = '#' + $(this).attr('id');
        var locale = $(this).data('locale');
        var value = $(this).val();
        var dateTimePicker = $(id).parent().datetimepicker({
            format: ffs_datetime_format,
            useStrict: true,
            locale: locale
        });

        // clean cache for FSForms.parseDateTime
        FSForms.removeDateTime(id);

        // set default value after render
        $(id).val(value);

        // store current value into session
        dateTimePicker.on('dp.change', function(e)
        {
            var id = '#' + $(this).children('input').attr('id');
            var val = $(id).val();
            window.live.removeError($(id));
            FSForms.saveDateTime(id, val);
        });

        // Triggers 'change' after hide picker. Support for metadata logic.
        dateTimePicker.on('dp.hide', function(e)
        {
            $(this).trigger('change');
        });

        // parse date time
        $(id).keyup(function(e)
        {
            var id = '#' + $(this).attr('id');
            var val = $(id).val();

            if(val != "")
            {
                if(e.keyCode == 9) // pressed TAB
                {
                    FSForms.saveDateTime(id, val);
                }
                else
                {
                    window.live.removeError($(id));
                    var dateTime = FSForms.parseDateTime(val);
                    FSForms.saveDateTime(id, dateTime);
                }
            }
        });

        // refresh date time
        $(id).focusout(function()
        {
            var id = '#' + $(this).attr('id');
            FSForms.refreshDateTimeValue(id);
        });

        // refresh date time
        dateTimePicker.on('dp.show', function(e)
        {
            var id = '#' + $(this).children('input').attr('id');
            FSForms.refreshDateTimeValue(id);
        });

        // fix tabindex
        var tabindexEl = $(id).closest('div[tabindex]');
        var tabindex = tabindexEl.attr('tabindex');
        $(id).prop('tabindex', tabindex);
        tabindexEl.removeProp('tabindex');
    });
};

/**
 * Init DateRangePicker controls.
 */
FSForms.processDateRangePicker = function()
{
    if($('#ffs_date_format').length)
    {
        var ffs_date_format =  $('#ffs_date_format').val();
    }
    else
    {
        var ffs_date_format =  'D.M.YYYY';
    }

    $('.fs-dateRange-picker').each(function()
    {
        var id = '#' + $(this).attr('id');
        var locale = $(this).data('locale');
        var parentEl = $(id).closest('.modal-body');
        var dateRangePicker = $(id).parent();
        var localizedStrings = $(this).data('localized');
        var value = ($(this).val() && $(this).val().split(' - ').length == 2 ? $(this).val().split(' - ') : null);
        var useVariables = $(this).data('variables');

        if(parentEl.length == 0)
        {
            parentEl = 'body';
        }
               
        dateRangePicker.daterangepicker({
            parentEl: parentEl,
            format: ffs_date_format,
            startDate: (value ? value[0] : moment()),
            endDate: (value ? value[1] : moment().add(1, 'days')),
            showDropdowns: true,
            showWeekNumbers: true,
            timePicker: false,
            timePickerIncrement: 1,
            timePicker12Hour: true,
            ranges:
            {
                ['default']: [moment(), moment().add(1, 'days')],
                [localizedStrings.today]: [moment(), moment()],
                [localizedStrings.yesterday]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                [localizedStrings.tomorrow]: [moment().add(1, 'days'), moment().add(1, 'days')],
                [localizedStrings.last7]: [moment().subtract(6, 'days'), moment()],
                [localizedStrings.next7]: [moment().add(1, 'days'), moment().add(7, 'days')],
                [localizedStrings.last30]: [moment().subtract(29, 'days'), moment()],
                [localizedStrings.next30]: [moment().add(1, 'days'), moment().add(30, 'days')],
                [localizedStrings.thisMonth]: [moment().startOf('month'), moment().endOf('month')],
                [localizedStrings.lastMonth]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                [localizedStrings.nextMonth]: [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]
            },
            opens: 'right',
            drops: 'down',
            buttonClasses: ['btn', 'btn-sm'],
            applyClass: 'btn-primary',
            cancelClass: 'btn-default',
            separator: ' - ',
            linkedCalendars: false,
            locale:
            {
                format: ffs_date_format,
                applyLabel: localizedStrings.apply,
                cancelLabel: localizedStrings.cancel,
                fromLabel: localizedStrings.from,
                toLabel: localizedStrings.to,
                customRangeLabel: localizedStrings.custom,
                daysOfWeek: [localizedStrings.sun, localizedStrings.mon, localizedStrings.tue, localizedStrings.wed, localizedStrings.thu, localizedStrings.fri, localizedStrings.sat],
                monthNames: [localizedStrings.jan, localizedStrings.feb, localizedStrings.mar, localizedStrings.apr, localizedStrings.may, localizedStrings.jun, localizedStrings.jul, localizedStrings.aug, localizedStrings.sep, localizedStrings.oct, localizedStrings.nov, localizedStrings.dec],
                firstDay: 1
            }}, function (start, end, label){
                if (useVariables && label != localizedStrings.custom && label != 'default'){
                    $(id).val('"' + label + '"');
                }else{
                    switch (label){
                        case localizedStrings.today: this.startDate = moment(); this.endDate = moment(); break;
                        case localizedStrings.yesterday: this.startDate = moment().subtract(1, 'days'); this.endDate = moment().subtract(1, 'days'); break;
                        case localizedStrings.tomorrow: this.startDate = moment().add(1, 'days'); this.endDate = moment().add(1, 'days'); break;
                        case localizedStrings.last7: this.startDate = moment().subtract(6, 'days'); this.endDate = moment(); break;
                        case localizedStrings.next7: this.startDate = moment().add(1, 'days'); this.endDate = moment().add(7, 'days'); break;
                        case localizedStrings.last30: this.startDate = moment().subtract(29, 'days'); this.endDate = moment(); break;
                        case localizedStrings.next30: this.startDate = moment().add(1, 'days'); this.endDate = moment().add(30, 'days'); break;
                        case localizedStrings.thisMonth: this.startDate = moment().startOf('month'); this.endDate = moment().endOf('month'); break;
                        case localizedStrings.lastMonth: this.startDate = moment().subtract(1, 'month').startOf('month'); this.endDate = moment().subtract(1, 'month').endOf('month'); break;
                        case localizedStrings.nextMonth: this.startDate = moment().add(1, 'month').startOf('month'); this.endDate = moment().add(1, 'month').endOf('month'); break;
                    }
                    $(id).val(this.startDate.format(ffs_date_format) + ' - ' + this.endDate.format(ffs_date_format));
                }
                window.live.removeError($(id));
            });

        // update size modal
        dateRangePicker.on('show.daterangepicker hide.daterangepicker', function(ev, picker)
        {
            if(parentEl != 'body' && parentEl.length == 1)
            {
                $(id).closest('.modal').modal('handleUpdate');
            }

            $(picker.container).find('input[name="daterangepicker_start"]').select().focus();

            var value = $(id).val();
            if (value.indexOf('"') === 0){
                $(picker.container).find('li[data-range-key="' + value.substring(1, value.length - 1) + '"]').addClass('active');
            }
        });

        // update text input after click on storno
        dateRangePicker.on('cancel.daterangepicker', function(ev, picker)
        {
            $(id).val(null);
            window.live.removeError($(id));
        });
    });

    // parse date time
    var dateRangePickerInputEl = $("input[name='daterangepicker_start'], input[name='daterangepicker_end']");

    dateRangePickerInputEl.focus(function()
    {
        $(this).select();
    });

    dateRangePickerInputEl.keyup(function(e)
    {
        if(e.keyCode == 9) // pressed TAB
        {
            return true;
        }

        var val = $(this).val();
        var _date = FSForms.parseDateTime(val);
        if(_date != INVALID_DATE)
        {
            var date = moment(_date, ffs_date_format).format(ffs_date_format);
            FSForms.saveDateTime(LAST_DATE_RANGE_PICKER_KEY, date);
        }
    });

    dateRangePickerInputEl.focusout(function()
    {
        var date = FSForms.loadDateTime(LAST_DATE_RANGE_PICKER_KEY);
        if(date != null)
        {
            $(this).val(date);
        }
    });

    dateRangePickerInputEl.change(function()
    {
        var date = FSForms.loadDateTime(LAST_DATE_RANGE_PICKER_KEY);
        if(date != null)
        {
            $(this).val(date);
        }
    });
};

/**
 * Init SelectSearch control.
 */
FSForms.processSelectSearch = function()
{
    // https://harvesthq.github.io/chosen
    $(".chosen_select_search").each(function()
    {
        var noResultsText = $(this).data('noresultstext');

        $(this).chosen({
            search_contains: true,
            no_results_text: noResultsText
        });
        $(this).on('change', function(evt, params){
            window.live.removeError($(this));
        });
    });
};

/**
 * Check valid date for dateTimePicker and timePicker before form submit.
 */
FSForms.checkValidDateTime = function()
{
    $('form').submit(function()
    {
        var valid = true;
        $(this).find('.fs-date-picker, .fs-dateTime-picker').each(function()
        {
            var val = $(this).val();
            //if(!moment(val, 'DD.MM.YYYY HH:mm:ss').isValid() && val != '' && val != '%IS NULL%')
            if(!moment(val, 'D.M.YYYY HH:mm:ss').isValid() && !moment(val, 'DD-MM-YYYY HH:mm:ss').isValid() && !moment(val, 'MM-DD-YYYY HH:mm:ss').isValid() && !moment(val, 'MM/DD/YYYY HH:mm:ss').isValid()  && val != '' && val != '%IS NULL%')
            {
                valid = false;
                alert('Chybný formát nebo datum.');
                $(this).focus();
                $(this).select();
                return false;
            }
        });

        if(valid == false)
        {
            return false;
        }
    });
};

/**
 *  Check valid date for dateRangePicker before form submit.
 */
FSForms.checkValidDateTimePicker = function()
{
    $('form').submit(function()
    {
        var valid = true;
        $(this).find('.fs-dateRange-picker').each(function()
        {
            var val = $(this).val();
            if(val == '' || val == '%IS NULL%')
            {
                return true;
            }

            var splitVal = val.split(' - ');
            if(!Array.isArray(splitVal) || !moment(splitVal[0], 'D.M.YYYY').isValid() || !moment(splitVal[1], 'D.M.YYYY').isValid())
            {
                valid = false;
                alert('Chybný formát nebo datum.');
                $(this).focus();
                $(this).select();
                return false;
            }
        });

        if(valid == false)
        {
            return false;
        }
    });
};

/**
 * Init Text Input Autocomplete
 */
FSForms.processTextInputAutocomplete = function()
{
    $('input[data-textInputAutocomplete=true]').each(function()
    {
        var id = '#' + $(this).attr('id');
        var url = $(this).data('autocompleteurl');
        var minLength = $(this).data('minlength');

        $(id).autocomplete({
            source: url,
            minLength: minLength,
            open: function ()
            {
                setTimeout(function () {$('.ui-autocomplete').css('z-index', 999999);}, 0);
                var acData = $(this).data('ui-autocomplete');
                acData.menu.element.find('li').each(function ()
                {
                    var me = $(this);
                    var keywords = acData.term.split(' ').join('|');
                    me.html(me.text().replace(new RegExp("(" + keywords + ")", "gi"), '<b>$1</b>'));
                });

                //close when scrollable parent is scrolled
                $(id).scrollParent().off('scroll').on('scroll', function(){ $(id).autocomplete('close'); });
            }
        });
    });
};

/**
 * @param id
 */
FSForms.refreshDateTimeValue = function(id)
{
    var control = $(id);
    var val = FSForms.loadDateTime(id);
    if(val != null)
    {
        if(val == INVALID_DATE)
        {
            control.val('Chybný formát nebo datum.');
        }
        else
        {
            control.val(val);
        }
    }
};

/**
 * @param string val
 */
FSForms.parseDateTime = function(val)
{
    var now = moment();
    var type = 0; // 0 - day; 1 - month; 2 - year
    var c = 0;

    var day = '';
    var month = '';
    var year = '';
    var hour = 0;
    var minute = 0;
    var second = 0;
    
    if($('#ffs_datetime_format').length)
    {  
      var ffs_datetime_format =  $('#ffs_datetime_format').val();
    }
    else
    {  
      var ffs_datetime_format =  'D.M.YYYY HH:mm:ss';
    }
    
    // parse input
    for(var i = 0; i < val.length; i++)
    {
        var char = val.charAt(i);

        if(char.match(/\D/))
        {
          if(c != 0)
          {
            if((type == 0 || type == 1) && c == 1)
            {
              c = 0;
            }
            type++;
          }
          continue;
        }
        
        c++;
                
        switch(type)
        {
            case 0:
                day += char;
                break;
            case 1:
                month += char;
                break;
            case 2:
                year += char;
                break;
        }

        if((type == 0 || type == 1) && c == 2)
        {
            c = 0;
            type++;
        }
      
        if(type == 2 && c == 5)
        {
            break;
        }
    }
    
    // fill missing values
    if(day == '')
    {
        day = now.format('D');
    }
    if(month == '')
    {
        month = now.format('M');
    }
    if(year == '' || year.length < 2)
    {
        year = now.format('YYYY');
    }
    if(day == now.format('D') && month == now.format('M') && year == now.format('YYYY'))
    {
        hour = now.format('H');
        minute = now.format('m');
        second = now.format('s');
    }

    // validation and store into session
    var dateTime = moment(day + '.' + month + '.' + year + ' ' + hour + ':' + minute + ':' + second, ffs_datetime_format);
    if(dateTime.isValid())
    {
        return dateTime.format(ffs_datetime_format);
    }
    else
    {
      return INVALID_DATE;
    }
};

/**
 Init SelectSearch Ajax picker
 */
FSForms.activateSelectAjaxPicker = function()
{
    $(".selectpicker-autojs").each(function( index )
    {
        var info = '';
        var link = $(this).data('link');
        var name = $(this).attr('name');
        var info_new = $(this).data('input-info');
        var minlength = $(this).data('minlength');

        var emptyTitle = $(this).data('locale-emptytitle');
        var currentlySelected = $(this).data('locale-currentlyselected');
        var statusInitialized = $(this).data('locale-statusinitialized');
        var statusSearching = $(this).data('locale-statussearching');
        var statusTooShort = $(this).data('locale-statustooshort');
        var statusNoResults = $(this).data('locale-statusnoresults');
        var formdata = $(this).data('formdata');

        if(info_new !== undefined)
        {
            info = info_new;
        }
        var id_selectpicker = $(this).attr('id');

        var options = {
            ajax          : {
                url     : link,
                type    : 'POST',
                dataType: 'json',
                data    : function() { // This is a function that is run on every request
                    if(formdata == 'no')
                    {
                        return {
                            search: '{{{q}}}',
                            name: name,
                            info: $('#'+id_selectpicker).data('input-info')
                        };
                    }
                    else
                    {
                        var formselectpicker = $('#'+id_selectpicker).parents('form:first');
                        var formselectpickerid = formselectpicker.attr('id');
                        var formselectpickerData =  JSON.stringify($('#'+formselectpickerid).serializeArray());

                        return {
                            search: '{{{q}}}',
                            name: name,
                            info: $('#'+id_selectpicker).data('input-info'),
                            formdata: formselectpickerData
                        };
                    }
                }
            },
            locale        : {
                emptyTitle: emptyTitle,
                currentlySelected: currentlySelected,
                statusInitialized: statusInitialized,
                statusSearching: statusSearching,
                statusTooShort: statusTooShort,
                statusNoResults: statusNoResults

            },
            log           : 3,
            minLength     : minlength,
            preprocessData: function (data) {

                var array = [];

                if(isEmpty(data) == false)
                {
                    var array = [];


                    for (var key in data) {
                        if (data.hasOwnProperty(key))
                        {
                            array.push($.extend(true, data[key], {
                                text : data[key],
                                value: key,
                            }));

                        }
                    }
                }


                // You must always return a valid array when processing data. The
                // data argument passed is a clone and cannot be modified directly.
                return array;
            }
        };

        $(this).selectpicker().filter('.with-ajax').ajaxSelectPicker(options);
        $(this).trigger('change');
    });
}

/**
 * @param string key
 * @param string value
 */
FSForms.saveDateTime = function(key, value)
{
    sessionStorage.setItem(key, value);
};

/**
 * @param string key
 */
FSForms.loadDateTime = function(key)
{
    return sessionStorage.getItem(key);
};

/**
 * @param string key
 */
FSForms.removeDateTime = function(key)
{
    sessionStorage.removeItem(key);
};


// WEBPACK FOOTER //
// ./client-side/Form/js/fsForms.js